import { render } from "./stub.vue?vue&type=template&id=e73198da&scoped=true"
import script from "./stub.vue?vue&type=script&lang=js"
export * from "./stub.vue?vue&type=script&lang=js"

import "./stub.vue?vue&type=style&index=0&id=e73198da&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e73198da"]])

export default __exports__